<div class="max-w-6xl mx-auto px-4 flex flex-col gap-20">
  <img
    class="sm:h-full h-44 w-full rounded-3xl"
    src="assets/imgs/banners/banner-7.png"
    alt="banner delivery"
  />
  <div class="-mb-8 flex w-full gap-4 items-center">
    <mobo-search
      class="grow"
      placeholder="Rodízio, hamburguer, Riversides..."
      [isDelivery]="true"
      (search)="search($event)"
    ></mobo-search>

    <mobo-filter-modal
      #filter
      (updateFilter)="addFilters($event)"
      (filterDone)="searchFilters()"
    >
      <div class="text-primary-500 flex gap-4 items-center mb-auto p-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M3.75 8.25002H6.84375C7.00898 8.89533 7.38428 9.4673 7.91048 9.87575C8.43669 10.2842 9.08387 10.5059 9.75 10.5059C10.4161 10.5059 11.0633 10.2842 11.5895 9.87575C12.1157 9.4673 12.491 8.89533 12.6562 8.25002H20.25C20.4489 8.25002 20.6397 8.17101 20.7803 8.03035C20.921 7.8897 21 7.69894 21 7.50002C21 7.30111 20.921 7.11035 20.7803 6.96969C20.6397 6.82904 20.4489 6.75002 20.25 6.75002H12.6562C12.491 6.10471 12.1157 5.53274 11.5895 5.12429C11.0633 4.71584 10.4161 4.49414 9.75 4.49414C9.08387 4.49414 8.43669 4.71584 7.91048 5.12429C7.38428 5.53274 7.00898 6.10471 6.84375 6.75002H3.75C3.55109 6.75002 3.36032 6.82904 3.21967 6.96969C3.07902 7.11035 3 7.30111 3 7.50002C3 7.69894 3.07902 7.8897 3.21967 8.03035C3.36032 8.17101 3.55109 8.25002 3.75 8.25002ZM9.75 6.00002C10.0467 6.00002 10.3367 6.088 10.5834 6.25282C10.83 6.41764 11.0223 6.65191 11.1358 6.926C11.2494 7.20009 11.2791 7.50169 11.2212 7.79266C11.1633 8.08363 11.0204 8.3509 10.8107 8.56068C10.6009 8.77046 10.3336 8.91332 10.0426 8.9712C9.75166 9.02908 9.45006 8.99937 9.17597 8.88584C8.90189 8.77231 8.66762 8.58005 8.5028 8.33338C8.33797 8.0867 8.25 7.7967 8.25 7.50002C8.25 7.1022 8.40804 6.72067 8.68934 6.43936C8.97064 6.15806 9.35218 6.00002 9.75 6.00002ZM20.25 15.75H18.6562C18.491 15.1047 18.1157 14.5327 17.5895 14.1243C17.0633 13.7158 16.4161 13.4941 15.75 13.4941C15.0839 13.4941 14.4367 13.7158 13.9105 14.1243C13.3843 14.5327 13.009 15.1047 12.8438 15.75H3.75C3.55109 15.75 3.36032 15.829 3.21967 15.9697C3.07902 16.1103 3 16.3011 3 16.5C3 16.6989 3.07902 16.8897 3.21967 17.0304C3.36032 17.171 3.55109 17.25 3.75 17.25H12.8438C13.009 17.8953 13.3843 18.4673 13.9105 18.8758C14.4367 19.2842 15.0839 19.5059 15.75 19.5059C16.4161 19.5059 17.0633 19.2842 17.5895 18.8758C18.1157 18.4673 18.491 17.8953 18.6562 17.25H20.25C20.4489 17.25 20.6397 17.171 20.7803 17.0304C20.921 16.8897 21 16.6989 21 16.5C21 16.3011 20.921 16.1103 20.7803 15.9697C20.6397 15.829 20.4489 15.75 20.25 15.75ZM15.75 18C15.4533 18 15.1633 17.912 14.9166 17.7472C14.67 17.5824 14.4777 17.3481 14.3642 17.074C14.2506 16.8 14.2209 16.4984 14.2788 16.2074C14.3367 15.9164 14.4796 15.6491 14.6893 15.4394C14.8991 15.2296 15.1664 15.0867 15.4574 15.0288C15.7483 14.971 16.0499 15.0007 16.324 15.1142C16.5981 15.2277 16.8324 15.42 16.9972 15.6667C17.162 15.9133 17.25 16.2034 17.25 16.5C17.25 16.8978 17.092 17.2794 16.8107 17.5607C16.5294 17.842 16.1478 18 15.75 18Z"
            fill="#3D5CF5"
          />
        </svg>
        Filtrar
      </div>
    </mobo-filter-modal>
  </div>

  <div
    class="flex flex-wrap items-center -my-8 gap-2"
    *ngIf="filters && filters[0]"
  >
    <div
      *ngFor="let filter of filters"
      class="flex gap-2 items-center px-3 py-1 rounded-full transition-all border-2 text-xs select-none text-slate-500 border-slate-300"
    >
      {{ filter.description }}
    </div>
    <div
      class="flex gap-2 items-center pl-3 rounded-full transition-all border-2 text-xs select-none text-error-500 border-error-500 cursor-pointer"
      (click)="clearFilter()"
    >
      Limpar filtros
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        class="fill-error-500"
      >
        <path
          d="M14.5031 9.46875C14.2102 9.17578 13.7356 9.17578 13.4425 9.46875L12 10.9406L10.5031 9.46875C10.2102 9.17578 9.73563 9.17578 9.4425 9.46875C9.14937 9.76172 9.14953 10.2362 9.4425 10.5294L10.9122 11.9991L9.46875 13.4688C9.17578 13.7617 9.17578 14.2362 9.46875 14.5294C9.76166 14.8223 10.2362 14.8225 10.5294 14.5294L12 13.0594L13.4697 14.5291C13.7626 14.822 14.2372 14.8222 14.5303 14.5291C14.8233 14.2361 14.8233 13.7616 14.5303 13.4684L13.0606 11.9988L14.5303 10.5291C14.8219 10.2375 14.8219 9.7625 14.5031 9.46875ZM12 4C7.58125 4 4 7.58125 4 12C4 16.4187 7.58125 20 12 20C16.4187 20 20 16.4187 20 12C20 7.58125 16.4187 4 12 4ZM12 18.5C8.41563 18.5 5.5 15.5841 5.5 12C5.5 8.41594 8.41563 5.5 12 5.5C15.5844 5.5 18.5 8.41594 18.5 12C18.5 15.5841 15.5844 18.5 12 18.5Z"
        />
      </svg>
    </div>
  </div>

  <mobo-coupon-list
    listTitle="Peça hoje mesmo"
    *ngIf="filteredDelivery![0]"
    [campaigns]="filteredDelivery"
    [showButton]="false"
  >
    <svg
      icon
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16 7.5C14.9122 7.5 13.8488 7.82257 12.9444 8.42692C12.0399 9.03126 11.3349 9.89025 10.9187 10.8952C10.5024 11.9002 10.3935 13.0061 10.6057 14.073C10.8179 15.1399 11.3417 16.1199 12.1109 16.8891C12.8801 17.6583 13.8601 18.1821 14.927 18.3943C15.9939 18.6065 17.0998 18.4976 18.1048 18.0813C19.1098 17.6651 19.9687 16.9601 20.5731 16.0556C21.1774 15.1512 21.5 14.0878 21.5 13C21.4983 11.5418 20.9184 10.1438 19.8873 9.11274C18.8562 8.08165 17.4582 7.50165 16 7.5ZM16 15.5C15.5055 15.5 15.0222 15.3534 14.6111 15.0787C14.2 14.804 13.8795 14.4135 13.6903 13.9567C13.5011 13.4999 13.4516 12.9972 13.548 12.5123C13.6445 12.0273 13.8826 11.5819 14.2322 11.2322C14.5819 10.8826 15.0273 10.6445 15.5123 10.548C15.9972 10.4516 16.4999 10.5011 16.9567 10.6903C17.4135 10.8795 17.804 11.2 18.0787 11.6111C18.3534 12.0222 18.5 12.5055 18.5 13C18.5 13.663 18.2366 14.2989 17.7678 14.7678C17.2989 15.2366 16.663 15.5 16 15.5ZM16 1.5C12.951 1.50331 10.0279 2.71597 7.87193 4.87193C5.71597 7.02788 4.50331 9.95103 4.5 13C4.5 22.67 14.705 29.925 15.14 30.2288C15.3921 30.4052 15.6923 30.4998 16 30.4998C16.3077 30.4998 16.6079 30.4052 16.86 30.2288C18.7928 28.8043 20.5612 27.1692 22.1325 25.3538C25.6437 21.3213 27.5 17.0462 27.5 13C27.4967 9.95103 26.284 7.02788 24.1281 4.87193C21.9721 2.71597 19.049 1.50331 16 1.5ZM19.9125 23.3388C18.7207 24.7078 17.4115 25.9701 16 27.1112C14.5885 25.9701 13.2793 24.7078 12.0875 23.3388C10 20.9213 7.5 17.1637 7.5 13C7.5 10.7457 8.39553 8.58365 9.98959 6.98959C11.5837 5.39553 13.7457 4.5 16 4.5C18.2543 4.5 20.4163 5.39553 22.0104 6.98959C23.6045 8.58365 24.5 10.7457 24.5 13C24.5 17.1637 22 20.9213 19.9125 23.3388Z"
        fill="#F5A70E"
      />
    </svg>
  </mobo-coupon-list>

  <div
    class="flex flex-col items-center gap-4 p-10"
    *ngIf="!filteredDelivery![0]"
  >
    <h3
      class="text-5xl font-semibold mb-6 text-center text-slate-400"
    >
      NENHUM CUPOM ENCONTRADO
    </h3>
    <img
      class="mx-auto"
      width="400"
      height="400"
      [ngSrc]="baseUrl + '/assets/imgs/empty-wallet.svg'"
      alt="Mobo"
    />
  </div>
</div>
